import React from "react";
import StatusStep from "./ui/status-step";
import { Asset } from "../types/asset";

interface StackMoreStatusStepProps {
  isSuccess: boolean;
  onContinue: () => void;
  asset: Asset;
}

const StackMoreStatusStep: React.FC<StackMoreStatusStepProps> = ({
  isSuccess,
  onContinue,
  asset,
}) => {
  const successConfig = {
    title: `You have stacked more ${asset?.assetName?.toUpperCase() || "BTC"}!`,
    description: "Keep tracking your automated crypto purchases",
    buttonText: "View Stacks",
  };

  const failureConfig = {
    title: `Failed to stack more ${asset?.assetName?.toUpperCase() || "BTC"}`,
    description: "Please try again or contact support if the issue persists",
    buttonText: "Try Again",
  };

  return (
    <StatusStep
      isSuccess={isSuccess}
      onContinue={onContinue}
      successConfig={successConfig}
      failureConfig={failureConfig}
    />
  );
};

export default StackMoreStatusStep;
